export function toLatLngLiteral({ minLat, maxLat, minLng, maxLng, }) {
    return [
        [minLat, minLng],
        [maxLat, maxLng],
    ];
}
//# sourceMappingURL=CoreTypes.js.map